module.exports = __webpack_public_path__ + "static/media/arrow_down_nospace.497db756.svg";